/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionalsode3Inputs */

const en_eventdescriptionalsode3 = /** @type {(inputs: Eventdescriptionalsode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also in German`)
};

const de_eventdescriptionalsode3 = /** @type {(inputs: Eventdescriptionalsode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auch auf Deutsch`)
};

/**
* | output |
* | --- |
* | "Also in German" |
*
* @param {Eventdescriptionalsode3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionalsode3 = /** @type {((inputs?: Eventdescriptionalsode3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionalsode3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionalsode3(inputs)
	return de_eventdescriptionalsode3(inputs)
});
export { eventdescriptionalsode3 as "eventDescriptionAlsoDe" }